import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../services/proptypes';
var defaultProps = {
  children: null
};
/**
 * This can be used to group items. For instance,
 * <Menu position="right">
 *    <Link {...someProps} />
 *    <Link {...someOtherProps} />
 *    <Link {...thirdProps} />
 * </Menu>
 */

function Menu(_ref) {
  var children = _ref.children,
      menuProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SemanticUIMenu.Menu, _extends({
    className: "site-navigation-menu"
  }, menuProps), children);
}

Menu.defaultProps = defaultProps;
export default Menu;